import script from "./shop.vue?vue&type=script&setup=true&lang=js"
export * from "./shop.vue?vue&type=script&setup=true&lang=js"

import "./shop.vue?vue&type=style&index=0&id=8fb3b290&lang=less"

const __exports__ = script;

export default __exports__